import { useState } from 'react';
import { glassBorder, glassText } from '../styles/overlayTokens';

interface PlayerAvatarProps {
  photoUrl?: string | null;
  name: string;
  size?: number;
  glowActive?: boolean;
  shape?: 'circle' | 'square';
}

export function PlayerAvatar({ photoUrl, name, size = 64, glowActive = false, shape = 'circle' }: PlayerAvatarProps) {
  const [imgError, setImgError] = useState(false);
  const showImage = photoUrl && !imgError;

  const initials = name
    .split(/\s+/)
    .map(w => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase() || '?';

  const glowStyle = glowActive
    ? { boxShadow: '0 0 14px rgba(255,134,92,0.6)' }
    : {};

  const borderRadius = shape === 'square' ? size * 0.15 : '50%';

  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: size,
        borderRadius,
        border: `2px solid ${glassBorder.medium}`,
        overflow: 'visible',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(255,255,255,0.06)',
        fontSize: size * 0.35,
        fontWeight: 700,
        color: glassText.secondary,
        ...glowStyle,
      }}
    >
      {glowActive && (
        <div
          style={{
            position: 'absolute',
            inset: -4,
            borderRadius,
            boxShadow: '0 0 16px rgba(255,134,92,0.7)',
            animation: 'glow-pulse 2s ease-in-out infinite',
            pointerEvents: 'none',
          }}
        />
      )}
      <div style={{ width: '100%', height: '100%', borderRadius, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {showImage ? (
          <img
            src={photoUrl}
            alt=""
            decoding="async"
            onError={() => { console.warn(`[PlayerAvatar] Failed to load photo: ${photoUrl}`); setImgError(true); }}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          initials
        )}
      </div>
    </div>
  );
}
